import { useDispatch } from 'react-redux';
import { setShowroomLeftNavOpen, useShowroomNavConfigSelector } from '@makemydeal/dr-sales-checkin-store';
import { HamburgerButton } from './navBarMobileItem.style';
import { HamburgerIcon } from '../Icons';

const NavBarMobileItem = () => {
    const dispatch = useDispatch();
    const { isHamburgerVisible } = useShowroomNavConfigSelector();

    // Manage Documents mounts no left nav (PageLayout's back-button variant), so the
    // drawer this opens would never appear -- hide it there like the desktop widths do.
    if (!isHamburgerVisible) {
        return null;
    }

    return (
        <HamburgerButton
            type="button"
            data-testid="showroom-header-hamburger"
            aria-label="Open navigation"
            onClick={() => dispatch(setShowroomLeftNavOpen(true))}
        >
            <HamburgerIcon fill="#FFFFFF" />
        </HamburgerButton>
    );
};

export default NavBarMobileItem;
